// * Import 3rd party lib
import { styled } from "@mui/material/styles";

// * Import Kit
import Box from "../../kit/Box";

// * Define required styled components
const StyledIcon = styled(
  Box,
  {}
)(({ theme, customProps }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: theme.fontWeight[500],
  color: theme.palette.secondary.main,
  "&:hover": { color: theme.palette.secondary.main },
  disabledIcon: {
    pointerEvents: "none",
    opacity: 0.5,
  },
}));

function Icon(props) {
  const {
    className = "material-symbols-rounded",
    iconName = "home",
    onClick = () => {},
    sx = {},
    title='',
  } = props;

  return (
    <>
      <StyledIcon
        className={`${className}`}
        component="span"
        sx={sx}
        onClick={onClick}
        title={title}
      >
        {iconName}
      </StyledIcon>
    </>
  );
}

export default Icon;
